import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home/Home';
import Coin from './Pages/Coin/Coin';
import { useEffect, useState } from 'react';
import myContext from './Context/Context';
function App() {
  const cryptoRouter=createBrowserRouter([
    {
      path:'/',
      element:<Home/>
    },
    {
      path:'/coin/:coinId?',
      element:<Coin/>
    }
  ]);
  const [apiData,setapiData]=useState();
  const [currency,setCurrency]=useState({name:"usd",symbol:"$"});
  useEffect(()=>{
    const options = {
      method: 'GET',
      headers: {accept: 'application/json', 'x-cg-demo-api-key': 'CG-rvbivjuMfidcYPN37BQ34rds'}
    };
    
    fetch(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency.name}`, options)
      .then(res => res.json())
      .then(res => setapiData(res))
      .catch(err => console.error(err));
  },[currency]);
  return (
    <myContext.Provider value={{apiData,currency,setCurrency}}>
    <div className="app">
     <RouterProvider router={cryptoRouter}/>
    </div>
    </myContext.Provider>
    
  );
}

export default App;
